module.exports = __webpack_public_path__ + "img/rect_blue_right.33962096.png";